<template>
  <!-- Données complémentaires -->
  <div class="h3">
    Vous nous avez par ailleurs communiqué les éléments suivants :
  </div>

  <div class="h4">
    Informations complémentaires
  </div>

  <ul>
    <li>Votre numéro de sécurité sociale : {{ numSecuToString(user.numSecu) }}</li>
    <li>Votre régime/caisse/centre de rattachement : {{ organismeToString(user.organisme) }}</li>
    <!-- Si le conjoint à assurer n'est pas un ayant droit -->
    <li v-if="user.conjoint === '1' && user.ayantDroit === '2'">
      Le numéro de sécurité sociale de votre conjoint : {{ numSecuToString(user.numSecuConjoint) }}
    </li>
    <li v-if="user.conjoint === '1' && user.ayantDroit === '2'">
      Le régime/caisse/centre de rattachement conjoint : {{ organismeToString(user.organismeConjoint) }}
    </li>
  </ul>

  <div class="h4">
    Prélèvement des cotisations
  </div>
  <ul>
    <li>Fractionnement : {{ user.libelleFractionnement }}</li>
    <li>Date de prélèvement : {{ user.jourPrelevementWBS }}</li>
    <li>Date d'effet souhaitée du contrat : {{ user.dateEffet }}</li>
  </ul>

  <div class="h4">
    Coordonnées bancaires
  </div>
  <ul>
    <li>Nom titulaire du compte : {{ user.nomTitulaire }}</li>
    <li>IBAN : {{ user.iban }}</li>
    <li>
      Coordonnées de l'établissement bancaire :
      <ul>
        <li>{{ user.nomBanque }}</li>
        <li>{{ user.addressBanque }}</li>
        <li>{{ user.codePostalBanque }} {{ user.villeBanque }}</li>
      </ul>
    </li>
  </ul>
</template>

<script>
import {numSecuToString} from "@/modules/shared/utils/numSecuUtils";
import {organismeToString} from "@/modules/shared/utils/organismeUtils";

export default {
  name: "RecapitulatifComplementaryInformations",
  props: {
    user: {
      type:Object,
      required: true
    }
  },
  methods: {
    numSecuToString: (value) => numSecuToString(value),
    organismeToString: (value) => organismeToString(value)
  }
}
</script>

<style scoped>

</style>
